import {
  SharedAccordionItemComponent,
} from '../../../../shared/shared-module-ui/components/shared-accordion/components/shared-accordion-item/shared-accordion-item.component';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {IPageObj, ISubPageObj} from '../../../../shared-utilities/models-old/page/page';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {FireAuthService} from '../../../../shared-utilities/services-old/fire-auth.service';
import {Store} from '@ngrx/store';
import {pageRules} from '../../../../shared-utilities/models-old/utils-old/rule-structure';
import {
  DESKTOP_PAGES,
  MOBILE_PAGES,
} from '../../../../shared-utilities/models-old/page/pages-const';
import {INavigate, IUser, IUserAccess} from '../../../user-access/models';
import {setPropertyOnUserState} from '../../../user-access/user-store/user.actions';
import {setNavigation, showNavigationLoading} from '../../../user-access/user-stores-store/user-store.actions';
import {
  NavigationPageEnum,
  NavigationPageType,
  NavigationTabEnum,
  NavigationTabType,
} from '../../../user-access/models/navigations.enums';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {storeHasAnyPageRule} from '../../../../shared/guards/guard-utils';
import {selectCurrentVersion} from '../../store-shared/shared.selectors';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false,
})
export class SideNavComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren(SharedAccordionItemComponent) accordionGroups: QueryList<SharedAccordionItemComponent>;

  @Input() defaultOpen?: boolean;
  @Input() subNav = false;
  @Input() navigation: INavigate;

  @Output() readonly sizeChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() readonly contractMenu: EventEmitter<void> = new EventEmitter<void>();

  pages: IPageObj[];
  userPages: IPageObj[] = [];
  subPages: ISubPageObj = {};
  clickCount = 0;
  icon: typeof IconsEnum = IconsEnum;
  showFullLogo = false;
  user: IUser;
  isMobile = false;
  currentYear = new Date().getFullYear();
  versionNumber: string;
  readonly iconColourEnum = IconColourEnum;
  protected readonly navigationPage = NavigationPageEnum;
  private menuExpanded = false;
  private menuFinishedExpanding = false;
  private menuCompactTimeout: NodeJS.Timeout;
  private userAccess: IUserAccess = {} as IUserAccess;
  protected readonly object = Object;

  constructor(
    private fireAuth: FireAuthService,
    private readonly store: Store,
    private cdr: ChangeDetectorRef,
  ) {
    this.isMobile = window.innerWidth < 600;
    this.pages = this.isMobile ? MOBILE_PAGES : DESKTOP_PAGES;
  }

  get isMenuExpanded(): boolean {
    return this.menuExpanded;
  }

  get getNavigationPage(): NavigationPageType {
    return this.navigation?.currentPage;
  }

  get getNavigationTab(): NavigationTabType {
    return this.navigation?.currentTab;
  }

  get hasMenuFinishedExpanding(): boolean {
    return this.menuFinishedExpanding;
  }

  @Input() set setNavigationPages(subPages: ISubPageObj) {
    subPages['auto-ordering'] = subPages['auto-ordering'].filter((page: IPageObj): boolean => page.tab !== 'unscheduled');
    this.subPages = subPages;
  }

  @Input() set setUser(user: IUser) {
    this.user = user;
    this.setPages();
  }

  @Input() set setUserAccess(userAccess: IUserAccess) {
    this.userAccessFlags(userAccess);
  }

  ngOnInit(): void {
    this.cdr.detectChanges();
    this.calledAfterInit();
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.menuCompactTimeout) {
      clearTimeout(this.menuCompactTimeout);
    }
  }

  increaseClickCount(): void {
    this.clickCount++;
  }

  /**
   * Phones use the single-store Stock Lookup item. Wider layouts keep Stock and Multi-Store.
   */
  @HostListener('window:resize')
  onWindowResize(): void {
    const isMobile = window.innerWidth < 600;
    if (isMobile === this.isMobile) {
      return;
    }
    this.isMobile = isMobile;
    this.pages = isMobile ? MOBILE_PAGES : DESKTOP_PAGES;
    this.setPages();
  }

  ngAfterViewInit(): void {
    this.store.dispatch(setPropertyOnUserState({property: 'isPageLoading', value: true}));
  }

  calledAfterInit(): void {
    this.menuFinishedExpanding = this.menuExpanded;
    if (!this.menuExpanded) {
      this.onMouseLeftMenu();
    }
    this.menuFinishedExpanding = false;

    if (this.navigation.currentPage === 'home' && !this.isMobile) {
      this.menuExpanded = true;
      this.menuFinishedExpanding = true;
      this.showFullLogo = true;
      this.emitSizeChange();
    }
    this.getCurrentVersionNumber();
  }

  getCurrentVersionNumber(): void {
    this.store
      .select(selectCurrentVersion)
      .pipe(take(1))
      .subscribe((version: string): void => {
        this.versionNumber = version;
      });
  }

  onToggleAccordion(acc?: string): void {
    if (this.accordionGroups) {
      this.accordionGroups.forEach((accordionGroup: SharedAccordionItemComponent): void => {
        if (acc === accordionGroup.id) {
          accordionGroup.isOpen = !accordionGroup.isOpen;
        } else {
          accordionGroup.isOpen = false;
        }
      });
    }
  }

  onNavigate(path: NavigationPageEnum, tab?: NavigationTabEnum): void {
    this.store.dispatch(showNavigationLoading({showLoadingIndicator: true}));
    this.store.dispatch(setNavigation({
      feature: path,
      navigation: {
        currentPage: path,
        currentTab: tab ? tab : null,
      },
    }));
    if (this.isMobile) {
      this.contractMenu.emit();
    }
    if (path === 'home') {
      this.onToggleMenu();
    }
  }

  resetTimeOut(): void {
    if (this.menuCompactTimeout) {
      clearTimeout(this.menuCompactTimeout);
      this.menuCompactTimeout = null;
      this.menuFinishedExpanding = this.menuExpanded;
    }
  }

  onMouseOverMenu(): void {
    if (this.isMenuExpanded) {
      this.menuFinishedExpanding = true;
    }
  }

  onMouseLeftMenu(): void {
    if (this.navigation.currentPage === 'home' && !this.isMobile) {
      return;
    }
    if (!this.menuCompactTimeout) {
      this.menuCompactTimeout = setTimeout((): void => {
        if (this.menuExpanded) {
          this.onToggleMenu();
        }
      }, 800);
    }
  }

  onToggleMenu(): void {
    if (this.navigation.currentPage === 'home' && !this.isMobile) {
      this.menuExpanded = true;
      this.menuFinishedExpanding = this.menuExpanded;
      this.emitSizeChange();
      return;
    }

    this.clickCount = 0;
    this.menuExpanded = !this.menuExpanded;
    this.onToggleAccordion();
    this.showFullLogo = !this.showFullLogo;
    this.menuFinishedExpanding = this.menuExpanded;

    this.emitSizeChange();
  }

  expandMenuOnAccClick(acc: string): void {
    if (!this.isMenuExpanded) {
      this.onToggleMenu();
      this.onToggleAccordion(acc);
    } else {
      this.onToggleAccordion(acc);
      this.onToggleAccordion(acc);
    }
  }

  /**
   * TODO: TECHNICAL DEBT -> private setPages(): void {}
   * This needs to be refactored and cleaned - Complexity to high
   * Also look at adding an enum for the pages and subpages - for checks etc
   *
   */
  private setPages(): void {
    this.applyUserPagesFilter();
    this.cdr.markForCheck();
  }

  private applyUserPagesFilter(): void {
    if (this.pages) {
      if (this.userAccess && this.user?.id) {
        this.userPages = this.pages?.filter((pageObj: IPageObj): boolean => {
          const rules = pageRules(pageObj.page);
          if (pageObj.page === 'settings') {
            return true;
          }
          // Empty rules (home/login) stay hidden here; Home is re-added below.
          if (!rules || rules.length === 0) {
            return false;
          }
          return this.userAccess?.storeList?.some((storeId: string) =>
            storeHasAnyPageRule(this.fireAuth, storeId, rules),
          ) ?? false;
        });
        if (!this.subNav) {
          this.userPages.unshift({page: NavigationPageEnum.Home, text: 'Home', icon: IconsEnum.home});
        }
      } else {
        const loginPage = this.pages.find((po: IPageObj) => po.page === 'home');
        this.userPages = loginPage ? [loginPage] : [];
      }
    }
  }

  private emitSizeChange(): void {
    this.sizeChange.emit(this.menuExpanded ? 'expand' : 'contract');
  }

  private userAccessFlags(userAccess: IUserAccess): void {
    this.userAccess = {} as IUserAccess;
    this.userAccess = userAccess;

    this.setPages();
  }
}
